import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 16px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 50%;
`;
